import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React from 'react';
import classnames from 'classnames';
import MinimalDumbo from '../MinimalDumbo';
import TextRenderer from '../../../TextRenderer';
import PollAnswerViewer from '../../../DaEditorWrapper/Viewer/PollAnswer';
import pollStyles from './Poll.scss';
const Answer = ({ textContent, image, answerId, percentvotes })=>{
    return /*#__PURE__*/ React.createElement("li", {
        className: classnames(pollStyles['answer'], pollStyles['answer-voted'])
    }, /*#__PURE__*/ React.createElement("div", {
        className: pollStyles['answer-row']
    }, image && /*#__PURE__*/ React.createElement(MinimalDumbo, {
        deviation: image,
        className: pollStyles['pollimage'],
        width: 72,
        height: 72
    }), /*#__PURE__*/ React.createElement(TextRenderer, {
        htmlExcerptLegacy: true,
        isPollWithHtmlExcerpt: true,
        textContent: textContent,
        className: classnames(pollStyles['answer-text'], 'da-editor-poll-thumb'),
        reactViewer: PollAnswerViewer,
        viewerKey: answerId
    }), /*#__PURE__*/ React.createElement("div", {
        className: pollStyles['percent']
    }, percentvotes, "%")), /*#__PURE__*/ React.createElement("div", {
        className: pollStyles['bar-wrapper']
    }, /*#__PURE__*/ React.createElement("div", {
        className: pollStyles['bar'],
        style: {
            width: `${percentvotes}%`
        }
    })));
};
const VotedAnswers = ({ poll })=>{
    return /*#__PURE__*/ React.createElement("ul", {
        className: classnames(pollStyles['voted'], pollStyles['answers'])
    }, poll.answers.map((answer)=>/*#__PURE__*/ React.createElement(Answer, _object_spread_props(_object_spread({}, answer), {
            key: `answer:${answer.answerId}`
        }))));
};
export default VotedAnswers;
